import React from "react";
import {useLoadUser} from "./useLoadUser";

export function UserName({userID}: {userID: string}) {
    const {data: user, isLoading} = useLoadUser(userID);
    if (isLoading) return <span className="inline-block h-3 w-24 rounded-full bg-light-light-grey animate-pulse" />;
    if (!user) return <span className="text-light-grey">—</span>;
    return <>{user.profile.firstName} {user.profile.lastName}</>;
}
